export default {
    AUTH: {
        VALIDATE: "/auth/token-is-valid",
    },
};
